import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { PublicLayout } from "../components/PublicLayout";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { BUILD_LABEL } from "../lib/buildInfo";
import { CHANGELOG, markChangelogSeen } from "../lib/changelog";
import { useLang } from "../context/LanguageContext";



export default function ChangelogPage() {
  const { t } = useLang();
  useEffect(() => {
    markChangelogSeen();
  }, []);

  return (
    <PublicLayout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 rounded-full border border-border bg-secondary/60 px-3 py-1 text-xs text-muted-foreground mb-4" data-testid="changelog-badge">
            <Sparkles className="w-3.5 h-3.5" />
            {BUILD_LABEL}
          </div>
          <h1 className="text-3xl sm:text-4xl font-heading font-semibold tracking-tight" data-testid="changelog-title">
            {t("Hva er nytt")}
          </h1>
          <p className="text-muted-foreground mt-2">
            {t("Right in blir bedre hele tiden. Her er de siste funksjonene for arrangører og publikum.")}
          </p>
        </div>

        <div className="space-y-5" data-testid="changelog-entries">
          {CHANGELOG.map((entry, i) => (
            <Card key={i} className="border-border" data-testid={`changelog-entry-${i}`}>
              <CardContent className="p-6">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h2 className="font-heading font-semibold text-lg">{entry.title}</h2>
                  <Badge variant="secondary" className="font-normal">{entry.date}</Badge>
                </div>
                <ul className="space-y-1.5 text-sm text-muted-foreground list-disc pl-5">
                  {entry.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>

        <p className="text-xs text-muted-foreground mt-6">
          <Link to="/" className="underline underline-offset-4" data-testid="changelog-home-link">{t("Tilbake til forsiden")}</Link>
        </p>
      </div>
    </PublicLayout>
  );
}
